import { render } from "./Deploy.vue?vue&type=template&id=045e27ec"
import script from "./Deploy.vue?vue&type=script&lang=js"
export * from "./Deploy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__